import { DistributionStatus } from '../../domain/enums/distribution-status';
import { SectorOverviewItem } from '../../domain/models';
import { DeviceDistribution } from '../../domain/models/distribution/device-distribution';
import { DistributionOverviewItem } from '../../domain/models/distribution/distribution-overview-item';
import { DeviceDistributionViewModel } from './device-distribution.view-model';

export class DistributionListItemViewModel {
    public distributionId: string;
    public sectorId: string;
    public noteId: string;
    public sectorDescription: string;
    public distributorName: string;
    public distributorPhoneNumber: string;
    public coachId: string;
    public technicalCycleId: string;
    public status: DistributionStatus;
    public distributionProgress: number;
    public distributionProgressEarly: number;
    public distributionProgressLate: number;
    public distributionProgressFull: number;
    public deviceDistributions: DeviceDistributionViewModel[];
    public lastUpdatedAt: Date;
    public distributionTiming: string;

    constructor();
    constructor(json: any, sector: any)
    constructor(json?: DistributionOverviewItem, sector?: SectorOverviewItem) {
        if (json) {
            this.distributionId = json.id;
            this.sectorId = json.sectorId;
            this.noteId = json.noteId;
            this.sectorDescription = json.sectorDescription;
            this.distributorName = json.distributor.name;
            this.distributorPhoneNumber = json.distributor.phoneNumber;
            this.distributionProgress = json.distributionProgress;
            this.distributionProgressEarly = json.distributionProgressEarly;
            this.distributionProgressLate = json.distributionProgressLate;
            this.distributionProgressFull = json.distributionProgress + json.distributionProgressEarly + json.distributionProgressLate;
            this.coachId = json.coachId;
            this.technicalCycleId = json.technicalCycleId;
            this.status = json.status;
            this.deviceDistributions = json.deviceDistributions.map((device: DeviceDistribution) => new DeviceDistributionViewModel(device));
            this.lastUpdatedAt = json.lastUpdatedAt ? new Date(json.lastUpdatedAt) : null;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/distribution/view-models/distribution-list-item.view-model.ts